(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/assets/javascripts/index.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/assets/javascripts/index.js');
"use strict";


const OddsetRouter = svs.oddset_kambi.OddsetRouter;
const {
  MaintenanceContextProvider
} = svs.oddset_kambi.components.maintenance_context;
const {
  BetsContextProvider
} = svs.oddset_kambi.components.bets_context;
const oddsmindConfig = svs.oddset_kambi.data.oddsmindConfig;
const isOddsmindChatLoaded = svs.oddset_kambi.data.isOddsmindChatLoaded;
const displayOddsmindChat = svs.core.detect.feature('ft-oddsmind-chat') && svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && isOddsmindChatLoaded;
ReactDOM.render(React.createElement(BetsContextProvider, null, React.createElement(MaintenanceContextProvider, null, React.createElement(OddsetRouter, null), displayOddsmindChat && React.createElement("oddsmind-chat", {
  "api-url": "https://chat.oddsmind.ai",
  "bookmaker-id": "32",
  "client-id": "svenskaspel",
  country: "SE",
  "footer-label": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.linkText) || 'OddsMind'),
  "footer-url": "".concat((oddsmindConfig === null || oddsmindConfig === void 0 ? void 0 : oddsmindConfig.link) || 'https://oddsmind.ai') 
  ,
  language: "sv",
  "parent-origin": "".concat(window.location.origin),
  position: "bottom-right"
  ,
  "widget-key": "widget_sOpEbLybS6h5QD201n6JpMZ12shh4_bvBGRfMO7e8E0" 
  ,
  "z-index": "301"
}))), document.getElementById('oddset-container'));

 })(window);